const GBP = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

export function formatPrice(pence: number): string {
  if (!Number.isInteger(pence)) {
    throw new Error(`Price must be integer pence, received ${pence}`);
  }
  if (pence < 0) {
    throw new Error(`Price must not be negative, received ${pence}`);
  }
  return GBP.format(pence / 100);
}
